<template>
	<el-drawer size="800px" title="绑定微博" :visible.sync="show" :modal-append-to-body="false" :wrapperClosable="false" :before-close="closeBox">
		<el-container class="bind-weibo">
			<el-header>
				<el-steps :active="active" simple>
				  <el-step title="绑定微博" icon="el-icon-edit"></el-step>
				  <el-step title="生成access_token" icon="el-icon-upload"></el-step>
				  <el-step title="完成绑定" icon="el-icon-success"></el-step>
				</el-steps>
			</el-header>
			<el-main>
				<BasicView @onConfirm="onBasicConfirm" v-if="active == 1" :show="show" v-on="$listeners"/>
				<CopyView v-if="active == 2" @onNext="onNext" :basicSource="basicSource" :source='source'/>
				<FinishView v-if="active == 3" @onPre="onPre" :copySource="copySource" :source='source' @onFinish="onFinish" v-on="$listeners"/>
			</el-main>
		</el-container>
	</el-drawer>
</template>

<script>
	import BasicView from './basic';
	import CopyView from './copy';
	import FinishView from './finish';
	export default {
		components:{
			BasicView,
			CopyView,
			FinishView
		},
		model:{
			prop:'show',
			event:'close'
		},
		props:{
			show:{
				default:false,
				type:Boolean
			},
			source:{
				default:''
			}
		},
		data(){
			return {
				active:1,
				basicSource:'',//第一步值
				copySource:'',//第二步值
			}
		},
		watch:{
			show(value){
				if(this.source && this.show){
					this.active = 2;
				}else {
					this.active = 1;
				}
			}
		},
		methods:{
			// 第一步结果
			onBasicConfirm(value){
				this.active = 2;
				this.basicSource = value;
			},
			// 第二步结果
			onNext(value){
				this.active = 3;
				this.copySource = Object.assign(value,this.basicSource);
			},
			closeBox(){
				this.$emit('close',false)
			},
			onPre(){
				this.active = 2;
			},
			onFinish(){
				this.closeBox();
			}
		}
	}
</script>

<style lang="scss" scoped>
	.bind-weibo {
		::v-deep {
			.el-step__title {
				font-size: 14px;
			}
		}
	}
</style>